import { LanguageService } from '../services/language.service';

export function languageAppInitializerFactory(languageService: LanguageService) {
  return () => languageService.initialize();
}
